import {Select, SelectProps} from "@mantine/core";
import {EShipmentTrackingTypes} from "../../../api/Shipment/Shipment.types";

interface Props extends Omit<SelectProps, "data"> {}

function ShipmentTrackingTypeSelect(props:Props){

    function getSelectData(){
        return Object.keys(EShipmentTrackingTypes).map((t) => ({ value:t, label:(EShipmentTrackingTypes as any)[t] }))
    }

    return (
        <Select data={getSelectData()} {...props}/>
    )

}

export default ShipmentTrackingTypeSelect;